package horcrux.frontend.common.extensions

import horcrux.common.ServerAppRoute
import horcrux.frontend.common.configs.ApplicationConfigs

val ServerAppRoute.url: String
    get() = "${ApplicationConfigs.BACKEND_URL}/${this.value}"
